module.exports = __webpack_public_path__ + "static/img/88062B_1_V_20201118_LC.8c7fcc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/88062B_1_V_20201118_LC.png
// module id = 6X2i
// module chunks = 0